import classNames from 'classnames'
import React, { useRef } from 'react'
// import InputMask from 'react-input-mask'
import { ErrorMessage, useFormikContext } from 'formik'
import { Card, Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { IMaskInput } from 'react-imask'
import { useParams } from 'react-router-dom'
import { CreateApplicationFormValues } from './CreateApplication'

const CreateApplicationBasic = (): React.ReactElement => {
  const { id } = useParams<{ id: string | undefined }>()
  const { t } = useTranslation('createApplication')
  const accountRef = useRef<HTMLInputElement>()
  const { getFieldProps, errors, touched, values, setFieldValue, setFieldTouched } =
    useFormikContext<CreateApplicationFormValues>()

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row>
          <Col>
            <h4>{t('thatttakandi')}</h4>
          </Col>
        </Row>

        <Row>
          <Col md="4">
            <p className="small text-muted">{t('thatttakandiHjalp')}</p>
          </Col>
          <Col md="8">
            <Form.Group controlId="ssn">
              <Form.Label>{t('kennitala')}*:</Form.Label>
              <IMaskInput
                autoFocus
                name="ssn"
                type="text"
                className={classNames('form-control', {
                  'is-invalid': touched.ssn && errors.ssn,
                })}
                mask={'000000-0000'}
                value={values.ssn}
                unmask={true}
                disabled={id != null}
                onAccept={(value: string) => setFieldValue('ssn', value)}
                onBlur={() => {
                  setFieldTouched('ssn')
                }}
              />
              <Form.Text className="text-muted">{t('kennitalaThatttakanda')}</Form.Text>
              <ErrorMessage name="ssn" component="div" className="invalid-feedback d-block text-left" />
            </Form.Group>

            <Form.Group controlId="name">
              <Form.Label>{t('nafn')}*:</Form.Label>
              <Form.Control
                type="text"
                className={classNames({
                  'is-invalid': touched.name && errors.name,
                })}
                readOnly
                {...getFieldProps('name')}
              />
              <Form.Text className="text-muted">{t('nafnThatttakanda')}</Form.Text>
              <ErrorMessage name="name" component="div" className="invalid-feedback d-block text-left" />
            </Form.Group>
            {/*
              <b-form-input
                data-vv-as="kennitala"
                :disabled="id != null"
              ></b-form-input>
            </b-form-group> */}
            {values.ssnValid && (
              <>
                <Form.Group controlId="email">
                  <Form.Label>{t('netfang')}*:</Form.Label>
                  <Form.Control
                    type="email"
                    className={classNames({
                      'is-invalid': touched.email && errors.email,
                    })}
                    {...getFieldProps('email')}
                  />
                  <Form.Text className="text-muted">{t('netfangThatttakanda')}</Form.Text>
                  <ErrorMessage name="email" component="div" className="invalid-feedback d-block text-left" />
                </Form.Group>

                <Form.Group controlId="mobile">
                  <Form.Label>{t('farsimi')}*:</Form.Label>
                  <Form.Control
                    type="text"
                    className={classNames({
                      'is-invalid': touched.mobile && errors.mobile,
                    })}
                    {...getFieldProps('mobile')}
                  />
                  <Form.Text className="text-muted">{t('farsimiThatttakanda')}</Form.Text>
                  <ErrorMessage name="mobile" component="div" className="invalid-feedback d-block text-left" />
                </Form.Group>

                <Form.Group controlId="account">
                  <Form.Label>{t('reikningur')}*:</Form.Label>
                  <IMaskInput
                    name="account"
                    className={classNames('form-control', {
                      'is-invalid': touched.account && errors.account,
                    })}
                    inputRef={(el: HTMLInputElement) => (accountRef.current = el)}
                    mask={(value: string): boolean => {
                      const c = (value.match(/-/g) || []).length

                      if (c === 0) {
                        return /^\d{0,4}$/.test(value)
                      }

                      if (c === 1) {
                        return /^\d{1,4}-\d{0,2}$/.test(value)
                      }

                      return /^\d{1,4}-\d{1,2}-\d{0,6}$/.test(value)
                    }}
                    value={values.account}
                    unmask={false}
                    onAccept={(value: string) => {
                      const addDash = /^\d{4}$/.test(value) || /^\d{4}-\d{2}$/.test(value)
                      const newValue = value + (addDash ? '-' : '')

                      setFieldValue('account', newValue)

                      if (addDash) {
                        setTimeout(() => {
                          if (accountRef.current != null) {
                            accountRef.current.setSelectionRange(newValue.length, newValue.length)
                          }
                        }, 50)
                      }
                    }}
                    onBlur={() => {
                      if (values.account) {
                        const split = values.account.split('-')
                        if (split.length === 3) {
                          const [book, bank, account] = split
                          setFieldValue(
                            'account',
                            `${book.padStart(4, '0')}-${bank.padStart(2, '0')}-${account.padStart(6, '0')}`
                          )
                        }
                      }
                      setFieldTouched('account')
                    }}
                  />
                  <Form.Text className="text-muted">{t('reikningurThatttakanda')}</Form.Text>
                  <Form.Text className="text-muted alert-info p-2 rounded font-italic">
                    {t('reikningurFramtidar')}
                  </Form.Text>
                  <ErrorMessage name="account" component="div" className="invalid-feedback d-block text-left" />
                </Form.Group>

                {(values.ageNow ?? 0) >= 16 && (
                  <Form.Group controlId="usePersonalAllowance">
                    <Form.Check
                      type="checkbox"
                      label={t('usePersonalAllowance')}
                      {...getFieldProps('usePersonalAllowance')}
                      checked={values.usePersonalAllowance}
                    />
                    <Form.Text className="text-muted">{t('usePersonalAllowanceHjalp')}</Form.Text>
                  </Form.Group>
                )}

                <Form.Group controlId="hasSpecialNeeds">
                  <Form.Check
                    type="checkbox"
                    label={t('hefurSertharfir')}
                    {...getFieldProps('hasSpecialNeeds')}
                    checked={values.hasSpecialNeeds}
                  />
                </Form.Group>

                {values.hasSpecialNeeds && (
                  <Form.Group controlId="specialNeeds">
                    <Form.Label>{t('sertharfir')}:</Form.Label>
                    <Form.Control as="textarea" {...getFieldProps('specialNeeds')} />
                    <Form.Text className="text-muted">{t('sertharfirEfAVid')}</Form.Text>
                  </Form.Group>
                )}

                <Form.Group controlId="other">
                  <Form.Label>{t('annad')}:</Form.Label>
                  <Form.Control as="textarea" {...getFieldProps('other')} />
                  <Form.Text className="text-muted">{t('annadEfAVid')}</Form.Text>
                </Form.Group>
              </>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default CreateApplicationBasic
